import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import css from './RaidMarkerPopup.module.css';
import {formatTime, getGymIcon, raidLevelMap} from "../../../utils";
import {pokemonIsWeatherBoosted} from "../../../utils/weatherBoost";
import forms from '../../../utils/forms';
import Directions from "../Directions";
import pokedex from "../../../utils/pokedex";

const RaidMarkerPopup = (props) => {
	const secsToBattle = props.raid.start - ((new Date()).getTime() / 1000);

	navigator.clipboard && navigator.clipboard.writeText(props.raid.latitude + ", " + props.raid.longitude);

	const weatherKey = Object.keys(props.weather).find(cellId => Math.abs(parseInt(props.raid['s2-10']) - parseInt(cellId)) < 0.0000000000001);
	const weatherIcon = weatherKey && (<img alt='Weather' src={'https://www.a2pogo.com/common/images/pokemon/weather/weather-' + props.weather['' + weatherKey] + '.png'} />);

	let form = null;
	if( props.raid.form ) {
		const pokemonForms = forms[props.raid.pokemon_id];
		form = <div	className={css.FormsLine}>{pokemonForms && pokemonForms[props.raid.form] ? pokemonForms[props.raid.form] + ' form' : 'Special form: ' + props.raid.form}</div>;
	}

	const gymTeams = ['Team Harmony', 'Mystic', 'Valor', 'Instinct'];

	const getMove = (moveId) => {
		if( !moveId || !props.moves || !props.moves[moveId] )
			return null;

		return (<div className={css.MoveLine}>
			<img alt={props.moves[moveId].name} src={'https://www.a2pogo.com/images/pokemon/types/' + props.moves[moveId].type + '-16.png'} />{props.moves[moveId].name}
		</div>);
	};

	const raidLevel = raidLevelMap.find(l => l.level === props.raid.level);
	const levelName = raidLevel ? raidLevel.name : "Unknown";

	return (<div className={css.RaidMarkerPopup}>
		<div className={css.HeaderLine}>
			{props.raid.pokemon_id ?
				pokedex[props.raid.pokemon_id]['name'] +  ' Raid ' :
				levelName + ' Raid '
			}
			at {props.raid.name}
			{weatherIcon}
		</div>

		<div className={css.TimingLine}>
			{secsToBattle < 0
				? 'Ends at ' + formatTime(new Date(props.raid.end * 1000))
				: 'Starts at ' + formatTime(new Date(props.raid.start * 1000))
			}
		</div>

		{form}

		{pokemonIsWeatherBoosted(props.raid.pokemon_id, props.raid['s2-10']) && <div className={css.WeatherBoostedLine}>Weather boosted</div>}

		{!props.raid.is_stale && <div className={css.GymControlLine}>
			<b>Gym Control:</b> {gymTeams[props.raid.team_id]} <img alt={props.raid.name} src={getGymIcon(props.raid)} />
		</div>}


		{props.raid.region && props.raid.region !== 'TODO' &&
			<div className='DiscordLine'>
				<b>Discord Channel:</b> #raid-{props.raid.region}
			</div>
		}

		{props.raid.park === 1 && <div className={css.ParkLine}>
			EX-eligible gym
			<img alt='EX-eligible' src='https://www.a2pogo.com/images/pokemon/ex-20.png' />
		</div>}

		{props.raid.move_1 !== 1 && <div className={css.MoveLines}>
			{getMove(props.raid.move_1)}
			{getMove(props.raid.move_2)}
		</div>}

		<Directions id={props.id} latitude={props.raid.latitude} longitude={props.raid.longitude} />
	</div>);
};

RaidMarkerPopup.propTypes = {
	raid: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
	return {
		weather: state.core.weather,
		moves: state.core.moves
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		// NAME: (value) => dispatch(FN(value)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(RaidMarkerPopup);